export default {"src":"/_next/static/media/garantiesatisfait.89562769.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};